<template>
  <v-container class="text-center card">
    <v-card>
      <v-card-title>
        <h3>Add New Post</h3>
      </v-card-title>

      <v-card-text>
        <v-form class="px-3" ref="form" @submit.prevent="onSubmit">
          <v-row>
            <v-col lg="6">
              <!-- post title -->
              <v-text-field
              name="name"
              label="Group Name"
              v-model="name"
              id="name"
              prepend-icon="mdi-format-title"
              required
              ></v-text-field>
            </v-col>

            <!-- add image -->
            <v-col lg="2">
                <div class="text-center">
                  <v-dialog
                  v-model="dialog"
                  width="500"
                  >
                  <template v-slot:activator="{ on }">
                    <v-btn
                    color="pTeal"
                    dark
                    v-on="on"
                    >
                    Add Group Chat Avatar
                  </v-btn>
                </template>

                <!-- on click popup -->
                <v-card>
                  <v-card-title
                  class="headline lightGrey"
                  primary-title
                  >
                  URL
                </v-card-title>

                <v-card-text>

                  <!-- add image -->
                  <v-form class="px-3" ref="form">
                    <v-text-field
                    label="Link"
                    name="imageURL"
                    v-model="imageUrl"
                    id="image-url"
                    prepend-icon="mdi-image"
                    ></v-text-field>
                  </v-form>

                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn
                  text
                  @click="dialog = false; submit"
                  >
                  Add
                </v-btn>
              </v-card-actions>

            </v-card>
          </v-dialog>
        </div>
    </v-col>
  </v-row>

  <!-- post image preview -->
  <v-row>
    <v-img
    :src="imageUrl"
    contain
    aspect-ratio="1.7"
    max-height="300px"
    ></v-img>
  </v-row>

  <!-- post content -->

  <v-row>

    <v-spacer></v-spacer>

    <v-btn class="mx-2" fab depressed text outlined color="indigo" :disabled="!formIsValid" @click="onCreateChat">
      <v-icon dark>mdi-plus</v-icon>
    </v-btn>
  </v-row>

</v-form>
</v-card-text>

</v-card>
</v-container>


</template>


<script>

export default {
  data: () => ({
    name: '',
    imageUrl: '',
    date:'',
    publicP: false,
    dialog: false,
  }),
  computed: {
    formIsValid () {
      return this.name !== '';
    }
  },
  methods: {
    onCreateChat () {

      const chatData = {
        name: this.name,
        imageUrl: this.imageUrl,
        lastMessage: '' + new Date(),
        owner: this.$store.state.user.id,
        members:[this.$store.state.user.id]
      }
      this.$store.dispatch('createChat', chatData)
      this.$router.push('/friends');
    },
  },
  mounted() {
    this.$store.dispatch('firebaseGetDMs')
    this.$store.dispatch('firebaseGetFriends')
    this.$store.dispatch('fetchFeed')
    this.$store.dispatch('fetchPrivateFeed')
    this.$store.dispatch('firebaseGetPostInteraction')
    this.$store.dispatch('firebaseDeletePosts')
    this.$store.dispatch('firebaseGetGroupChat')
    this.$store.dispatch('firebaseGetNotifications')
  }

}
</script>

<style lang="css" scoped>
.card {
  max-width: 60%;
}
</style>
